import {AiOutlineInstagram} from 'react-icons/ai'
import {AiOutlineFacebook} from 'react-icons/ai'
import {AiOutlineDribbble} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

const data = [
    {id: 1, link: 'https://www.instagram.com/mouin_boubakri/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://www.facebook.com/mouin.boubakri.75', icon: <AiOutlineFacebook/>},
    {id: 3, link: 'https://dribbble.com/M0uin', icon: <AiOutlineDribbble/>},
    {id: 4, link: 'https://github.com/Mouin-bkr', icon: <AiFillGithub/>}
]

export default data